import { Welcome, Typography, Select } from "components";
import { useEffect, useState } from "react";
import makeRequest from "services/makeRequest";
import { useSelector } from "react-redux";
import { routes } from "routes/apiRoutes";
import { formatUrlQuery } from "utils/helper";
import {
  setSelectedAgent,
  setSelectedTerminal,
} from "redux/actions/dashboard/terminalDashboardActions";
import { setTransactionQuery } from "redux/actions/transactionActions";

const TransactionHeader = () => {
  const { user, agentId, selectedTerminal } = useSelector((state) => ({
    user: state.user?.user,
    agentId: state.terminalDashboardReducer.agentId,
    selectedTerminal: state.terminalDashboardReducer.selectedTerminal,
  }));

  const [agentsToDisplay, setAgentsToDisplay] = useState({
    agents: [
      { label: "All", value: "" },
      { label: `${user.lastname} ${user.firstname}`, value: user.agent_id },
    ],
    loading: false,
  });

  const [terminalsToDisplay, setTerminalsToDisplay] = useState({
    terminals: [],
    loading: false,
  });

  const agentsQueryParams = {
    size: 100,
    parentId: user?.agent_id,
    userType: "AGENT_USER",
    sorted: true,
  };

  useEffect(() => {
    const getAggregatorAgents = async () => {
      setAgentsToDisplay({
        ...agentsToDisplay,
        loading: true,
      });
      try {
        const { data } = await makeRequest(
          "get",
          routes.getAgentPersonalDetails(formatUrlQuery(agentsQueryParams))
        );
        const aggregatorAgents = data.data?.content.map((agent) => ({
          label: `${agent.lastName} ${agent.firstName}`,
          value: agent.agentDetails.agentId,
        }));

        setAgentsToDisplay({
          ...agentsToDisplay,
          agents: [...agentsToDisplay.agents, ...aggregatorAgents],
          loading: false,
        });
      } catch (error) {
        setAgentsToDisplay({
          ...agentsToDisplay,
          loading: false,
        });
      }
    };
    getAggregatorAgents();
    //eslint-disable-next-line
  }, []);

  const getAgentTerminals = async (agentId) => {
    setTerminalsToDisplay({
      ...terminalsToDisplay,
      loading: true,
    });
    try {
      const { data } = await makeRequest(
        "get",
        routes.fetchTerminals(formatUrlQuery({ agentId, size: 100 }))
      );

      const agentsTerminals = data?.data?.content?.map(({ terminalId }) => ({
        label: `Terminal ${terminalId}`,
        value: terminalId,
      }));

      setTerminalsToDisplay({
        ...terminalsToDisplay,
        terminals: agentsTerminals,
        loading: false,
      });
    } catch (error) {
      setTerminalsToDisplay({
        ...terminalsToDisplay,
        loading: false,
      });
    }
  };

  return (
    <div className="terminal-header-selections-container">
      <Welcome />
      <div className="terminal-header-selections">
        <div className="terminal-select-container d-flex align-items-center px-2 mb-4">
          <Typography variant="body3" state="primary">
            Choose Agent:{" "}
            <Select
              required={false}
              value={agentId}
              loading={agentsToDisplay.loading}
              options={agentsToDisplay.loading ? [] : agentsToDisplay.agents}
              onChange={(e) => {
                const val = e.target.value;
                if (val) {
                  getAgentTerminals(val); //Dont make request to get terminals if aggregator selects all
                }
                setSelectedAgent(val);
                setTransactionQuery({
                  name: "terminalId",
                  value: "",
                });
              }}
              name=""
            />
          </Typography>
        </div>

        {agentId && (
          <div className="transaction-choice-container d-flex align-items-center px-2 mb-4">
            <Typography variant="body3">Choose Terminal:</Typography> &nbsp;{" "}
            <Select
              required={false}
              loading={terminalsToDisplay.loading}
              options={
                terminalsToDisplay.loading
                  ? []
                  : [
                      { label: "All Terminals", value: undefined },
                      ...terminalsToDisplay.terminals,
                    ]
              }
              value={selectedTerminal}
              onChange={(e) => setSelectedTerminal(e.target.value)}
              name=""
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionHeader;
